import React, {useState, useEffect, useContext, useRef} from "react";
import {useHistory} from 'react-router-dom';
import {functions} from "../../constants/common-functions";
import {store} from '../../context/store';
import {STRINGIFY} from "../../constants/general-constants";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {JWT} from "../../constants/local-storage";

export default function AdministrationSvg(){

	const history = useHistory();
	const [mainFacilityId, setMainFacilityId] = useState("-100");
	const [facilityId, setFacilityId] = useState("-1");
	const [facilities, setFacilities] = useState([]);
	const [svgWidth, setSvgWidth] = useState();
	const [svgHeight, setSvgHeight] = useState();
	const [viewboxDimensions, setViewboxDimensions] = useState("");
	const [originalFacilities, setOriginalFacilities] = useState([]);
	const [facilityEditPanelDisplay, setFacilityEditPanelDisplay] = useState("none");
	const [selectedFacilityName, setSelectedFacilityName] = useState("");
	const [allFacilities, setAllFacilities] = useState([]);
	const [svgBackground, setSvgBackground] = useState("");
	const [parentFacilityId, setParentFacilityId] = useState("-100");
	const [parentFacilityLoaded, setParentFacilityLoaded] = useState(false);
	const globalState = useContext(store);
	const svgId = useRef(null);
	
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		backgroundColor:"white",
		overflow:"auto",
		height:"100%",
		paddingBottom:"200px"
	};
	
	const refFacilitySelect = useRef(null);
	
	useEffect(() => {
		setViewboxDimensions("0 0 " + svgWidth + " " + svgHeight);
		
		if(allFacilities.length === 0){
			getAllFacilities();
		}
		else{
			if(parentFacilityId != "-100"){
				if(parentFacilityLoaded === false){
					loadSvgImage();
					loadChildFacilities();
					setParentFacilityLoaded(true);
				}
				else{
					
				}
			}
		}
		
	}, [parentFacilityId, facilities]);	
	
	
	const loadSvgImage = () => {
		
		let selectedParentFacility = allFacilities.find(x => x.id === parseInt(parentFacilityId));
		
		if(selectedParentFacility){
			let svgImageDimensions = selectedParentFacility.svgImageDimensions;
			try{
				setSvgWidth(svgImageDimensions.split(",")[0]);
				setSvgHeight(svgImageDimensions.split(",")[1]);
			}
			catch(e){}
			loadBackground(globalState.state.client.resourceFolderUrl + "/buildingphotos/" + selectedParentFacility.code + "/" + selectedParentFacility.planFile);
		}
		
	};
	
	const loadChildFacilities = () => {
		functions.getArrayFromAjax("/resolution/admingetfacilitychildfacilities?facilityId=" + parentFacilityId, null, loadOriginalFacilities);
	};
	
	const loadOriginalFacilities = (facilities) => {
		setFacilities(facilities);
		for(let i=0; i<facilities.length; i++){
				originalFacilities.push({
					id:facilities[i].id,
					svg:facilities[i].svg
				});
			}
	}
	
	const loadBackground = (imageUrl) => {
		fetch(imageUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    }).then(result => result.blob())
	    .then(result => {
	    	setSvgBackground(URL.createObjectURL(result));
	    });
	};
	
	const getAllFacilities = () => {
		functions.getArrayFromAjax("/resolution/admingetmultifacilityfacilities", setAllFacilities, null);
	};
	
	const facilityNavigator = {
		display:"flex",
		flexDirection:"column",
		width:"340px"
	};
	
	const facilityButton = {
		display:"flex",
		width:"100%",
		height:"40px",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		fontSize:"12px",
		borderBottom:"1px solid rgba(255,255,255,0.3)",
		cursor:"pointer"
	};
	
	const facilityButtonColor = {
		display:"flex",
		width:"20px",
		height:"100%"
	};
	
	const facilityButtonName = {
		display:"flex",
		width:"calc(100% - 20px)",
		paddingLeft:"10px"
	};
	
	const facilityListDisplay = facilities.map((item, index) =>
		<div style={facilityButton} onClick={() => selectFacility(item.id)}>
			<div style={{...facilityButtonColor, backgroundColor:functions.getVividColor(index)}}/>
			<div style={facilityButtonName}>
				{item.name}
			</div>
		</div>
	);
	
	const transparentPolygon = {
		display:"flex",
		opacity:'0.7'
	};
	
	const facilityPolygons = facilities.map((item, index) =>
		<polygon points={item.svg}
            fill={functions.getVividColor(index)} stroke={functions.getVividColor(index)} style={transparentPolygon}/>
	);
	
	const scrollableContainer = {
		display:"flex",
		width:"calc(100% - 340px)",
		height:"9000px",
		overflow:"scroll",
		whiteSpace:'nowrap',
		backgroundColor:"red"
	};
	
	const svgPanel = {
		display:"flex",
		backgroundImage:'url(' + svgBackground + ')',
		backgroundSize:'100% auto'
	};
	
	const pushNewSvgCoordinate = (x, y) => {
		let tempFacilities = facilities;
		setFacilities([]);
		
		let facility = tempFacilities.find(x => x.id === facilityId);
		
		if(facility){
			if(facility.svg != null){
				facility.svg = facility.svg + ' ' + x + ',' + y;
			}
			else{
				facility.svg = x + ',' + y
			}
		}
		
		const timer = setTimeout(() => {setFacilities(tempFacilities)}, 10);
	};
	
	const handleSvgClick = (e) => {
		console.log(svgId.current.getBoundingClientRect());
		let svgClickLeft = e.clientX - svgId.current.offsetLeft + (410 - svgId.current.getBoundingClientRect().left);
		let svgClickTop = e.clientY - svgId.current.offsetTop - svgId.current.getBoundingClientRect().top + 70;
		pushNewSvgCoordinate(svgClickLeft, svgClickTop);
	}; 
	
	const facilityEditPanel = {
		position:"absolute",
		left:"60px",
		top:"70px",
		width:"350px",
		backgroundColor:"black",
		height:"100%",
		flexDirection:"column"
	};
	
	const selectParentFacility = () => {
		setParentFacilityLoaded(false);
		setParentFacilityId(refFacilitySelect.current.value);
	};
	
	const selectFacility = (id) => {
		setFacilityId(id);
		let facility = facilities.find(x => x.id === id);
		
		if(facility){
			setSelectedFacilityName(facility.name);
			setFacilityEditPanelDisplay("flex");
		}
		
	};
	
	const editFacilityName = {
		display:"flex",
		width:"100%",
		height:"40px",
		alignItems:"center",
		justifyContent:"space-around",
		fontSize:"14px",
		color:"white",
		backgroundColor:"darkred"
	};
	
	const clearPolygon = () => {
		let tempFacilities = facilities;
		setFacilities([]);
		
		let facility = tempFacilities.find(x => x.id === facilityId);
		
		if(facility){
			facility.svg = '';
		}
		const timer = setTimeout(() => {setFacilities(tempFacilities)}, 10);
	};
	
	const revertPolygon = () => {
		let tempFacilities = facilities;
		setFacilities([]);
		
		let facility = tempFacilities.find(x => x.id === facilityId);
		let originalFacility = originalFacilities.find(x => x.id === facilityId);
		
		if(facility && originalFacility){
			facility.svg = originalFacility.svg;
		}
		
		console.log(tempFacilities);
		const timer = setTimeout(() => {setFacilities(tempFacilities)}, 10);
	};
	
	const undoPolygonLast = () => {
		let tempFacilities = facilities;
		setFacilities([]);
		
		let facility = tempFacilities.find(x => x.id === facilityId);
		
		if(facility){
			try{
				let tempSvg = '';
				
				let newArray = facility.svg.split(" ");
				newArray.pop();
				
				for(let i=0; i<newArray.length; i++){
					tempSvg = tempSvg + " " + newArray[i];
				}
							
				facility.svg = tempSvg;
			}
			catch(e){}
		}
		const timer = setTimeout(() => {setFacilities(tempFacilities)}, 10);
	};
	
	const cancelPolygon = () => {
		setFacilityId("-1");
		setFacilityEditPanelDisplay("none");
	};
	
	const facilitySaveError = (e) => {
		alert(e);
	};
	
	const handleFacilitySave = () => {
		setFacilityId("-1");
		setFacilityEditPanelDisplay("none");
	};
	
	const savePolygon = () => {
		let facility = facilities.find(x => x.id === facilityId);
		if(facility){
			functions.submitAjax("/resolution/facilitysave", facility, handleFacilitySave, STRINGIFY, facilitySaveError);
		}
	};
	
	const buttonContainer = {
		display:"flex",
		width:"100%",
		height:"40px",
		alignItem:"center",
		justifyContent:"space-around"
	};
	
	const goClose = () => {
		history.push('/administrationhome');
	};
	
	const selectContainer = {
		display:"flex",
		width:"calc(100% - 20px)",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		height:"40px",
		paddingLeft:"20px",
		borderBottom:"1px solid rgba(255,255,255,0.3)"
	};
	
	const navigatorButton = {
		display:"flex",
		width:"100%",
		height:"30px",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		cursor:"pointer",
		borderBottom:"1px solid rgba(255,255,255, 0.2)",
		fontSize:"14px"
	};
	
	const thisSelect = {
		display:"flex",
		width:"200px"
	};
	
	const optionDisplay = allFacilities.map((item, index) => 
		<option value={item.id}>
			{item.name}
		</option>
	);

	return (
		
			<div style={thisContainer}>
			<div style={facilityNavigator}>
				<div style={facilityButton} onClick={goClose}>
					Close
				</div>
				<div style={selectContainer}>
					<select 
						onChange={selectParentFacility}
						ref={refFacilitySelect}
						style={thisSelect}
					>
						<option value="-100">Select</option>
						{optionDisplay}
					</select>
				</div>
				{facilityListDisplay}
			</div>
			<div style={scrollableContainer}>
				
				<div style={svgPanel} ref={svgId}>
					<svg viewBox={viewboxDimensions} xmlns="http://www.w3.org/2000/svg" style={{width:svgWidth + "px", height:svgHeight + "px"}} onClick={handleSvgClick}>
						{facilityPolygons}
					</svg>
				</div>
			</div>
			<div style={{...facilityEditPanel, display:facilityEditPanelDisplay}}>
				<div style={editFacilityName}>
					{selectedFacilityName}
				</div>
			
				<div style={navigatorButton} onClick={clearPolygon}>
					Clear Polygon
				</div>
				
				<div style={navigatorButton} onClick={undoPolygonLast}>
					Undo
				</div>
					
				<div style={navigatorButton} onClick={revertPolygon}>
					Revert Polygon
				</div>
		
				<div style={navigatorButton} onClick={cancelPolygon}>
					Cancel
				</div>
				
				<div style={navigatorButton} onClick={savePolygon}>
					Save
				</div>
			</div>
		</div>
	
	);
}